import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '525571164745';
  const message = encodeURIComponent('Hola, me interesa información sobre UPIM');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 rounded-full border border-[rgba(245,247,250,0.18)] bg-green-600 p-4 text-white shadow-lg transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-green-500 group"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="h-6 w-6" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        ¿Necesitas ayuda?
      </span>
    </a>
  );
};

export default WhatsAppButton;
